import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AddButton from '../../components/AddButton';
import ModalDetail from '../../components/DetailModal';
import SearchAdvance from '../../components/SearchAdvance';
import SearchAdvanceForm from '../../components/SearchAdvanceForm';
import SearchBar from '../../components/SearchBar';
import PaginatedTable from '../../components/PaginatedTable';
import PrintOptions from '../../components/Print/PrintOptions';
import PrintFilterDisplay from '../../components/Print/PrintFilterDisplay';

const TransaksiSingkong = () => {
  const [transaksi, setTransaksi] = useState([]);
  const [search, setSearch] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [fromTanggalVerifikasi, setFromTanggalVerifikasi] = useState('');
  const [toTanggalVerifikasi, setToTanggalVerifikasi] = useState('');
  const [supplier, setSupplier] = useState('');
  const [idAngkutan, setIdAngkutan] = useState('');
  const [noKendaraan, setNoKendaraan] = useState('');
  const [beratBersihMin, setBeratBersihMin] = useState('');
  const [beratBersihMax, setBeratBersihMax] = useState('');
  const [jenisVarietas, setJenisVarietas] = useState('');
  const [selectedTransaksi, setSelectedTransaksi] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showFields, setShowFields] = useState(false);
  const [selectedPrintOption, setSelectedPrintOption] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem('transaksiSingkong')) || [];

    if (!stored || stored.length === 0) {
      const dummy = Array.from({ length: 30 }).map((_, i) => {
        const tanggalNota = new Date(2025, 4, (i % 30) + 1);
        const tanggalVerifikasi = new Date(tanggalNota);
        tanggalVerifikasi.setDate(tanggalNota.getDate() + Math.floor(Math.random() * 3 + 1));

        return {
          NoNota: `NOTA-${1000 + i}`,
          KodeReferensi: `REF-${2000 + i}`,
          TanggalNota: tanggalNota.toISOString().split('T')[0],
          TanggalVerifikasi: tanggalVerifikasi.toISOString().split('T')[0],
          IdAngkutan: `ANGK-${i + 1}`,
          NoKendaraan: `B${1000 + i}XYZ`,
          Supplier: `Supplier ${i % 5}`,
          BeratBersih: (Math.random() * 1000).toFixed(2),
          Premi: (Math.random() * 50000).toFixed(2),
          KomisiBersih: (Math.random() * 70000).toFixed(2),
          JenisVarietas: ['Kuning', 'Putih', 'Merah'][i % 3],
          KadarAci: '',
          Gross: '',
          Tare: '',
          Netto: '',
          Refraksi: '',
          beratbersih: '',
          harga: '',
          PBongkarSPM: '',
          TotalHargaSPM: '',
          PBongkarSTN: '',
          TotalHargaSTN: '',
          KomisiGrossPerKG: '',
          KomisiGross: '',
          PremiPerKG: '',
          LpPerKG: '',
          LoyaltyPts: '',
          StatusTransaksi: '',
          DitambahkanOleh: '',
          DiubahOleh: '',
        };
      });
      localStorage.removeItem('transaksiSingkong');
      localStorage.setItem('transaksiSingkong', JSON.stringify(dummy));
      setTransaksi(dummy);
    } else {
      setTransaksi(stored);
    }
  }, [location]);

  const filteredTransaksi = transaksi
    .map((item, originalIndex) => ({ ...item, originalIndex }))
    .filter((item) => {
      if (fromDate && item.TanggalNota < fromDate) return false;
      if (toDate && item.TanggalNota > toDate) return false;
      if (fromTanggalVerifikasi && item.TanggalVerifikasi < fromTanggalVerifikasi) return false;
      if (toTanggalVerifikasi && item.TanggalVerifikasi > toTanggalVerifikasi) return false;
      if (supplier && !item.Supplier?.toLowerCase().includes(supplier.toLowerCase())) return false;
      if (idAngkutan && !item.IdAngkutan?.toLowerCase().includes(idAngkutan.toLowerCase())) return false;
      if (noKendaraan && !item.NoKendaraan?.toLowerCase().includes(noKendaraan.toLowerCase())) return false;
      if (beratBersihMin && Number(item.BeratBersih) < Number(beratBersihMin)) return false;
      if (beratBersihMax && Number(item.BeratBersih) > Number(beratBersihMax)) return false;
      if (jenisVarietas && !item.JenisVarietas?.toLowerCase().includes(jenisVarietas.toLowerCase())) return false;
      if (search && ![item.NoNota, item.KodeReferensi, item.IdAngkutan, item.NoKendaraan, item.Supplier, item.BeratBersih, item.Premi, item.KomisiBersih].some((field) => field?.toString().toLowerCase().includes(search.toLowerCase()))) {
        return false;
      }
      return true;
    });

  const handleEdit = (filteredIndex) => {
    const originalIndex = filteredTransaksi[filteredIndex].originalIndex;
    const dataToEdit = transaksi[originalIndex];
    localStorage.setItem('editTransaksiSingkong', JSON.stringify(dataToEdit));
    navigate(`/add-transaksi-singkong?edit=true&index=${originalIndex}`, { state: { data: dataToEdit } });
  };

  const handleDelete = (filteredIndex) => {
    if (window.confirm('Yakin ingin menghapus data ini?')) {
      const originalIndex = filteredTransaksi[filteredIndex].originalIndex;
      const updated = [...transaksi];
      updated.splice(originalIndex, 1);
      setTransaksi(updated);
      localStorage.setItem('transaksiSingkong', JSON.stringify(updated));
    }
  };

  const handleView = (filteredIndex) => {
    const originalIndex = filteredTransaksi[filteredIndex].originalIndex;
    setSelectedTransaksi(transaksi[originalIndex]);
    setShowDetailModal(true);
  };

  const handlePrint = (option) => {
    setSelectedPrintOption(option); // menampilkan filter sesuai pilihan
  };

  const handleClearFilters = () => {
    setFromDate('');
    setToDate('');
    setFromTanggalVerifikasi('');
    setToTanggalVerifikasi('');
    setSupplier('');
    setIdAngkutan('');
    setNoKendaraan('');
    setBeratBersihMin('');
    setBeratBersihMax('');
    setJenisVarietas('');
    setSearch('');
  };

  return (
    <div className="pt-10 pl-64">
      <h2 className="pl-6 mb-6 text-2xl font-semibold text-green-700">Transaksi Singkong</h2>
      <div className="p-6 mx-4 bg-white shadow rounded-xl">
        <div className="flex items-center justify-between mb-4">
          {/* Kiri: Add dan Print */}
          <div className="flex items-center gap-2">
            <AddButton onClick={() => navigate('/add-transaksi-singkong')}  moduleName="Transaksi Singkong" />
            <PrintOptions onPrintOptionSelected={handlePrint} />
          </div>

          {/* Kanan: Search */}
          <div className="flex items-center gap-2">
            <SearchBar value={search} onChange={setSearch} />
            <SearchAdvance showFields={showFields} toggleShowFields={() => setShowFields(!showFields)} />
          </div>
        </div>
        <PrintFilterDisplay option={selectedPrintOption} data={filteredTransaksi} onClose={() => setSelectedPrintOption('')} />

        {showFields && (
          <SearchAdvanceForm
            dateFields={[
              {
                label: 'Tanggal Nota',
                fromValue: fromDate,
                toValue: toDate,
                onFromChange: setFromDate,
                onToChange: setToDate,
              },
              {
                label: 'Tanggal Verifikasi',
                fromValue: fromTanggalVerifikasi,
                toValue: toTanggalVerifikasi,
                onFromChange: setFromTanggalVerifikasi,
                onToChange: setToTanggalVerifikasi,
              },
            ]}
            additionalFields={[
              { label: 'Supplier', value: supplier, onChange: setSupplier },
              { label: 'Nama/ID Angkutan', value: idAngkutan, onChange: setIdAngkutan },
              { label: 'No Kendaraan', value: noKendaraan, onChange: setNoKendaraan },
              { label: 'Berat Bersih Min', value: beratBersihMin, onChange: setBeratBersihMin, type: 'number' },
              { label: 'Berat Bersih Max', value: beratBersihMax, onChange: setBeratBersihMax, type: 'number' },
              { label: 'Jenis Varietas', value: jenisVarietas, onChange: setJenisVarietas },
            ]}
            onClear={handleClearFilters}
          />
        )}

        <PaginatedTable
          data={filteredTransaksi}
          columns={[
            { key: 'NoNota', label: 'No Nota' },
            { key: 'KodeReferensi', label: 'Kode Referensi' },
            { key: 'TanggalNota', label: 'Tanggal Nota' },
            { key: 'TanggalVerifikasi', label: 'Tanggal Verifikasi' },
            { key: 'IdAngkutan', label: 'Nama/ID Angkutan' },
            { key: 'NoKendaraan', label: 'No Kendaraan' },
            { key: 'Supplier', label: 'Supplier' },
            { key: 'BeratBersih', label: 'Berat Bersih' },
            { key: 'Premi', label: 'Premi' },
            { key: 'KomisiBersih', label: 'Komisi Bersih' },
          ]}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onView={handleView}
          moduleName="Transaksi Singkong"
        />

        {showDetailModal && <ModalDetail data={selectedTransaksi} onClose={() => setShowDetailModal(false)} />}
      </div>
    </div>
  );
};

export default TransaksiSingkong;
